<template lang="pug">
  .row(v-if="registration.program.administrative_fee_percentage>0")
    .columns.large-24
        article.content-block
            section.content
                .row
                    .columns.large-12
                        | {{t('app.registration.administrative_fee')}}
                        |
                        span(:aria-label="t('app.program.payment.administrative_fee.tooltip')",data-balloon-pos="up",data-balloon-length="large")
                            span.icon-help
                            br
                        template(v-for="ppm in registration.program.product_payment_methods.filter((pm) => !pm.payment_method_no_administrative_fees)")
                          | {{ppm.payment_method_name}}
                          br
                    .columns.large-12
                        .right
                            | {{registration.program.administrative_fee_percentage}}%

</template>

<script>
  import helpers from 'code/base_mixins'
  export default {
    name: "administrative_fees",
    mixins: [helpers],
    computed: {
      registration(){
        return this.state.current_reg
      },
    },
  }
</script>
